var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vip-level-icon",attrs:{"src":require(("../../../assets/vip/L" + _vm.level + ".png"))}})}
var staticRenderFns = []

export { render, staticRenderFns }